import React from 'react';
import { IconSvgProps } from '@models/common';

const EditSquare: React.FC<IconSvgProps> = (props) => {
  const { size = 20, strokeWidth = 1.5, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M7.5 4.16667H5.16667C4.23333 4.16667 3.76667 4.16667 3.41 4.34833C3.09638 4.50807 2.84141 4.76304 2.68167 5.07667C2.5 5.43333 2.5 5.9 2.5 6.83333V14.8333C2.5 15.7667 2.5 16.2333 2.68167 16.59C2.84145 16.9036 3.09641 17.1585 3.41 17.3183C3.76583 17.5 4.2325 17.5 5.16417 17.5H13.1692C14.1008 17.5 14.5667 17.5 14.9225 17.3183C15.2367 17.1583 15.4917 16.9033 15.6517 16.59C15.8333 16.2333 15.8333 15.7675 15.8333 14.8358V12.5M12.5 5L7.5 10V12.5H10L15 7.5M12.5 5L15 2.5L17.5 5L15 7.5M12.5 5L15 7.5'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default EditSquare;
